import {Component, OnInit, HostListener, Inject} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {CookieService} from 'ngx-cookie-service';
import {Router} from '@angular/router';


@Component({
  standalone: false,
  selector: 'app-index',
  templateUrl: './index.component.html'
})
export class IndexComponent implements OnInit {
  constructor(private cookieService: CookieService, private route: Router) {
  }

  username: any = '';
  customercode: any = '';
  email: any = '';
  isAdmin: any = false;

  ngOnInit(): any {
    this.username = this.cookieService.get('user_name');
    this.email = this.cookieService.get('email');
    this.customercode = this.cookieService.get('customer_code');
    if (this.cookieService.get('is_admin') &&
      this.cookieService.get('is_admin') == 'yes') {
      this.isAdmin = true;
    }
  }

  logout() {
    this.cookieService.delete(AuthenticationService.sessionKey);
    this.route.navigate(['/login']);
  }
}
